export class Watching {
    constructor(host) {
        this.unwatches = [];
        host.addController(this);
    }
    watch(...unwatches) {
        if (unwatches.length)
            this.unwatches.push(...unwatches);
        return this;
    }
    hostDisconnected() {
        this.unwatches.forEach(unwatch => unwatch());
        this.unwatches = [];
    }
}
export function Watchable(handlerName, skipInitial) {
    return function (prototype, propertyName) {
        const valueKey = `___${propertyName}`;
        const handlerKey = handlerName || `${propertyName}Changes`;
        const callbacks = new Map();
        Object.defineProperty(prototype, valueKey, {
            value: prototype[propertyName],
            writable: true,
        });
        Object.defineProperty(prototype, handlerKey, {
            value: (callback) => {
                // initial
                const currentVal = prototype[valueKey];
                if (!skipInitial && currentVal !== undefined) {
                    callback(currentVal, undefined);
                }
                // add callback & return unwatch
                const callbackId = Symbol();
                callbacks.set(callbackId, callback);
                return () => callbacks.delete(callbackId);
            },
        });
        Object.defineProperty(prototype, propertyName, {
            get: () => prototype[valueKey],
            set: newValue => {
                let oldValue = prototype[valueKey];
                oldValue =
                    !oldValue || typeof oldValue !== 'object'
                        ? oldValue
                        : JSON.parse(JSON.stringify(oldValue));
                prototype[valueKey] = newValue;
                callbacks.forEach(callback => callback === null || callback === void 0 ? void 0 : callback(newValue, oldValue));
            },
        });
    };
}
export function Watch() {
    return function (prototype, propertyName) {
        const watcherKey = Symbol();
        Object.defineProperty(prototype, propertyName, {
            get: function () {
                const watching = (this[watcherKey] || (this[watcherKey] = new Watching(this)));
                return watching.watch.bind(watching);
            },
        });
    };
}
//# sourceMappingURL=watch.js.map